import { render, staticRenderFns } from "./modalVerInventario.vue?vue&type=template&id=651a54ec"
import script from "./modalVerInventario.vue?vue&type=script&lang=js"
export * from "./modalVerInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports